import React, { ReactNode } from "react";
import {
    Container,
    CardBody,
    CardBodyProps,
    CardTitle,
    CardTitleProps,
    CardText,
    CardTextProps,
    Card,
    CardProps,
} from "reactstrap";

import { Breadcrumbs, BreadcrumbsItem } from "../Breadcrumbs";

interface PageProps {
    style?: "card" | "blank";
    fluid?: boolean;
    className?: string;
    breadcrumbs?: BreadcrumbsItem[];
    children?: ReactNode;
}

interface PageElementProps {
    className?: string;
    children?: ReactNode;
    tag?: React.ElementType;
}

const Page = ({ style, fluid, className, breadcrumbs, children }: PageProps) => {
    const Wrap: React.ElementType = fluid ? "div" : Container;
    return (
        <div className="page">
            <Wrap className={className}>
                {breadcrumbs != null && fluid && <Container><Breadcrumbs items={breadcrumbs} /></Container>}
                {breadcrumbs != null && !fluid && <Breadcrumbs items={breadcrumbs} />}
                {(style == null || style === "blank") && children}
                {(style === "card") &&
                    <Card>{children}</Card>
                }
            </Wrap>
        </div>
    );
};

const PageCard = (props: CardProps) => (
    <Card {...props}>{props.children}</Card>
);

const PageCardBody = (props: CardBodyProps) => (
    <CardBody {...props}>{props.children}</CardBody>
);

const PageTitle = ({ tag, children, ...props }: PageElementProps) => {
    const Tag = tag || "h1";
    return <Tag {...props}>{children}</Tag>;
};

const PageCardTitle = (props: CardTitleProps) => (
    <CardTitle {...props}>{props.children}</CardTitle>
);

const PageCardText = (props: CardTextProps) => (
    <CardText {...props}>{props.children}</CardText>
);

export {
    Page,
    PageProps,
    PageTitle,
    PageCard as Card,
    PageCardBody as CardBody,
    PageCardText as CardText,
    PageCardTitle as CardTitle,
};
